module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAsCAMAAAAtr3oOAAAANlBMVEUAAADtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmTtZmRZ/tX9AAAAEXRSTlMA3+9AYI9vIL8QMK+fgH/PUD3uzn0AAADESURBVHhe7dC7isRADAXRK/Xbr5n6/59dmGnwJsYKFjbxiRQUF7r1MepqXLI167fs3LB81gV6bbq05A7lrL3qRja2eeGLbjXnu2lUBSR8fMZNIf0zu5IV8qZLMhaFNFwSKAj+L3/yJ39yIylkwSUVDoXsbJISsfnm3+6Aqltvp0izt5qGLo20d9g0ZePUm6bUOXnVKZXuTDZmfaavcvW8ZmzzoIzQD+yS9GJVRIIs7VhTSMWXDE1BBXMOhXUoihtmQ3/hB10gEalRcOuTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/img/icons/inbox-hover.png
// module id = 1018
// module chunks = 0